export default function UserService($http, env, UserSessionService) {
	"ngInject";

	const path = `${env.apiUrl}/maps-user`;

	const UserService = {
		getUser: () => (
			$http.get(path, {cache: true}).then((response) => (
				response.data
			))
		),
		getSettings: () => (
			UserService.getUser().then((user) => (
				user.settings
			))
		),
		getUserMission: () => (
			UserService.getUser().then((user) => {
				if (user.mission) {
					return user.mission;
				} else {
					return UserSessionService.load().then((results) => {
						let asglocId = results.activeMission ? results.activeMission.missionId : null;
						if (asglocId) {
							return $http.get(`${path}/mission`).then((response) => (
								response.data
							));
						}
					}, angular.noop);
				}
			})
		)
	};
	return UserService;
}
